export enum CacheTime {
  None = 0,
  OneMinute = 60,
  TwoMinutes = 120,
  ThreeMinutes = 180,
  FiveMinutes = 300,
  Forever = Number.MAX_VALUE
}
